import './Product-new.css';
import Availability from '../Availability';
import availabilityTip from '../Common/availabilityTip';
import constants from '../../Utils/constants'


function Publicability(props) {
    if(props.Publicability === 'published')
        return <section className="publicability"><span className='label'>Stato MEPA:</span><span>Pubblicato</span></section>
    else if(props.Publicability === 'publishing')
        return <section className="publicability"><span className='label'>Stato MEPA:</span><span>Pubblicabile</span><span><a href={`mailto:info@virtual-logic.it?subject=[Richiesta Pubblicazione WEB] ${props.VLX}&body=Si richiede gentilmente la pubblicazione del seguente codice: ${props.VLX}`}>Richiedi Pubblicazione</a></span></section>
    else if(props.Publicability === 'on_request')
        return <section className="publicability"><span className='label'>Stato MEPA:</span><span>Su richiesta</span><span><a href={`mailto:info@virtual-logic.it?subject=[Richiesta Pubblicazione WEB] ${props.VLX}&body=Si richiede gentilmente la pubblicazione del seguente codice: ${props.VLX}`}>Richiedi Pubblicazione</a></span></section>
    else
        return <></>
}

function AvailabilitySection(props) {
    if(props.availability === null || parseInt(props.availability) === 0)
        return <section className="availability-text"><span className='label'>Disponibilità:</span><span>Attualmente non disponibile</span></section>
    else if(props.availability <= 10)
        return <section className="availability-text"><span className='label'>Disponibilità:</span><span>Meno di 10</span></section>
    else if(props.availability <= 50)
        return <section className="availability-text"><span className='label'>Disponibilità:</span><span>10+</span></section>
    else if(props.availability <= 100)
        return <section className="availability-text"><span className='label'>Disponibilità:</span><span>50+</span></section>
    else if(props.availability <= 200)
        return <section className="availability-text"><span className='label'>Disponibilità:</span><span>100+</span></section>
    else
        return <section className="availability-text"><span className='label'>Disponibilità:</span><span>200+</span></section>
}

function IncomingAvailabilityQuantitySection(props) {
    if(props.IncomingAvailability === null || parseInt(props.IncomingAvailability) === 0)
    {
        if (props.MinArrivalDate === null || props.MaxArrivalDate === null)
            return <>Nessun dato disponibile</>
        else
            return <>Nuovi arrivi previsti</>
    }
    else if(props.IncomingAvailability <= 10)
        return <>Meno di 10</>
    else if(props.IncomingAvailability <= 50)
        return <>10+</>
    else if(props.IncomingAvailability <= 100)
        return <>50+</>
    else if(props.IncomingAvailability <= 200)
        return <>100+</>
    else
        return <>200+</>
}

function IncomingAvailabilityDateSection(props) {
    if(props.MinArrivalDate === null || props.MaxArrivalDate === null)
        return <></>
    let print = new Intl.DateTimeFormat(undefined, {year: 'numeric', month: '2-digit', day: '2-digit' });
    let minDate = Date.parse(props.MinArrivalDate)
    let maxDate = Date.parse(props.MaxArrivalDate)
    if(minDate === maxDate)
        return <> in data {print.format(minDate)}</>
    else
        return <> tra il {print.format(minDate)} e il {print.format(maxDate)}</>
}

function IncomingAvailabilitySection(props) {
    return (
        <section className="incoming-availability-text">
            <span className='label'>Arrivi:</span>
            <span>
            <IncomingAvailabilityQuantitySection IncomingAvailability={props.IncomingAvailability} MinArrivalDate={props.MinArrivalDate} MaxArrivalDate={props.MaxArrivalDate}/>
            <IncomingAvailabilityDateSection MinArrivalDate={props.MinArrivalDate} MaxArrivalDate={props.MaxArrivalDate}/>
            </span>
        </section>
    )
}


function Product(props) {
    return (
        <article className="product modern">
            <div className='container'>
                <section className="image" style={{backgroundImage: `url(${constants.baseUrl+props.Image})`}}></section>
                <section className="descr">
                    <span>{props.ShortDescr}</span>
                </section>
                <div className='dati-principali'>
                    <section className="vlx"><span className='label'>Codice MEPA: </span><span><mark style={{padding: "1px 5px"}}>{props.VLX}</mark></span></section>
                    <section className="productCode"><span className='label'>Codice Produttore: </span><span>{props.ProductCode}</span></section>
                    <section className="manufacturer"><span className='label'>Produttore: </span><span>{props.Manufacturer}</span></section>
                </div>
                <div className='dati-dispo'>
                    <AvailabilitySection availability={parseInt(props.Availability)}/>
                    <IncomingAvailabilitySection IncomingAvailability={props.IncomingAvailability} MinArrivalDate={props.MinArrivalDate} MaxArrivalDate={props.MaxArrivalDate}/>
                    <Publicability Publicability={props.Publicability} VLX={props.VLX}/>
                </div>
                <section className="schedaTecnicaButton">
                    <span className='label'>
                        <button className='pulsante-scheda-tecnica' disabled={props.schedaTecnica ? false : true} href='#' onClick={event => {event.preventDefault();props.onClick()}}>
                            SCHEDA TECNICA
                        </button>
                    </span>
                </section>
            </div>
            
        </article>
    );
}

export default Product;